import PowerPointSlideProcessor from '@app/services/export/ppt/slides/PowerPointSlideProcessor';

export default class PowerPointSlideProcessorStub extends PowerPointSlideProcessor<any> {
	public async processSlideData(): Promise<void> {
		// stub
	}

	public getSlideIdsForSlideData(): string[] {
		return [];
	}
}
